export class Constantes {

    public OBJ_DESCRIPCION: any = {
        desc_catalogo: 'Consulte disponibilidad de datos publicados por el Banco de la República',
        desc_dashboard: 'Consulte cuadros y graficos pre-construidos por los técnicos del Banco',
        desc_visualizador: 'Grafique usted mismo datos publicados por el Banco de la República',
        desc_shopping: 'Realice búsqueda de múltiples series de datos para rangos de tiempo y periodicidades definidas por usted',
        desc_boletines: 'Consulte boletines económicos preparados por el Banco de la República',
        desc_calendario: 'Consulte fechas de publicación de los datos',
        desc_estadisticaEncuesta: 'Consulta datos de encuestas económicas del Banco de la República',
        desc_historico: 'Consulte las series de datos vintage publicadas por el Banco en el pasado',
        desc_instrucciones: 'Consulte instrucciones de diligenciamiento',
        desc_audiorespuesta: 'Consulte indicadores económicos diarios, descarguelos o envíelos a su correo electrónico',
        desc_webservice: 'Consulte disponibilidad de web Services para consumo de aplicaciones corporativas',
        desc_certificacionCalidad: 'Consulte datos publicados por el banco y certificados por el DANE'
    };

    public OBJ_TEMAS_TASA_CAMBIO_SECTOR_EXTERNO_DERIVADOS: any = [
        { tema: 'TCSED_TC_TRM' },
        { tema: 'TCSED_TC_INTRADIA', url: '' },
        { tema: 'TCSED_TC_MID' },
        { tema: 'TCSED_TC_MD' },
        { tema: 'TCSED_TC_TCPV' },
        { tema: 'TCSED_TC_MR' },
        { tema: 'TCSED_TC_BC' },

    ];

    public urlCatalogo: string = 'catalogo';
    public urlBoletines: string = 'boletines';
    public urlCalendario: string = 'calendario';
    public urlEncuesta: string = 'encuestas';
    public urlInstrucciones: string = 'instrucciones';
    public urlWebservice: string = 'webService';
    public urlCertificacionCalidad: string = 'certificaciones';
    public urlTablasPreconstruidas: string = 'dashboard';

    public ext: string = '.jpg';
    public getUrlImg(name: string) {
        var responseImg: string;
        responseImg = '/estadisticas-economicas/assets/img/menu-inicial/' + name + this.ext;
        return responseImg;
    }

    public TIPO_URL_INTERNA: string = 'INTERNO';
    public TIPO_URL_EXTERNA: string = 'EXTERNO';

    public DIAS_SEMANA: Array<string> = ['DOM', 'LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB'];
    public MESES_ANNIO: Array<string> = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    public MESES_ANNIO_ABREVIADO: Array<string> = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

    public ENCABEZADO_GENERAL_SIN_DATA: any = [
        //{ titulo: 'Categoría', clase: 'celda-enc-texto-medio' },
        { titulo: 'Descripción de la serie', clase: 'celda-enc-texto-largo' },
        //{ titulo: 'Periodicidad', clase: 'celda-enc-texto-corto' },
        //{ titulo: 'Unidad de medida', clase: 'celda-enc-texto-corto' },
        { titulo: 'Vinculo a los datos', clase: 'celda-enc-imagen' }
    ];

    public ENCABEZADO_GENERAL: any = [
        { titulo: 'Descripción de la serie', clase: 'celda-enc-texto-largo' },
        { titulo: 'Unidad de medida', clase: 'celda-enc-texto-corto' },
        { titulo: 'Periodicidad', clase: 'celda-enc-texto-corto' },
        { titulo: 'Disponible desde', clase: 'celda-enc-fecha' },
        { titulo: 'Disponible hasta', clase: 'celda-enc-fecha' },
        { titulo: 'Último dato disponible', clase: 'celda-enc-numero' },
        { titulo: 'Fecha del último dato disponible', clase: 'celda-enc-fecha' },
        { titulo: 'Fecha programada de la siguiente publicación', clase: 'celda-enc-fecha' },
        { titulo: 'Dato publicado este mes', clase: 'celda-enc-numero' }
    ];

    public ENCABEZADO_TASA_CAMBIO: any = [
        { titulo: 'Categoría', clase: 'celda-enc-texto-medio' },
        { titulo: 'Clasificación', clase: 'celda-enc-texto-medio' },
        { titulo: 'Indicador', clase: 'celda-enc-texto-largo' },
        { titulo: 'Periodicidad', clase: 'celda-enc-texto-corto' },
        { titulo: 'Fecha última publicación disponible', clase: 'celda-enc-fecha' },
        { titulo: 'Unidad de medida', clase: 'celda-enc-texto-corto' },
        { titulo: 'Fecha último dato publicado', clase: 'celda-enc-fecha' },
        { titulo: 'Último dato publicado', clase: 'celda-enc-numero' },
        { titulo: 'Tipo de tasa de cambio', clase: 'celda-enc-texto-corto' },
        { titulo: 'Vinculo a los datos', clase: 'celda-enc-imagen' },
        { titulo: 'Fecha de proxima publicación', clase: 'celda-enc-fecha' }
    ];

    public ENCABEZADO_TASA_CAMBIO_VECINOS: any = [
        { titulo: 'Categoría', clase: 'celda-enc-texto-medio' },
        { titulo: 'Indicador', clase: 'celda-enc-texto-largo' },
        { titulo: 'Periodicidad', clase: 'celda-enc-texto-corto' },
        { titulo: 'Fecha última publicación disponible', clase: 'celda-enc-fecha' },
        { titulo: 'Unidad de medida', clase: 'celda-enc-texto-corto' },
        { titulo: 'Fecha último dato publicado', clase: 'celda-enc-fecha' },
        { titulo: 'Último dato publicado', clase: 'celda-enc-numero' },
        { titulo: 'Tipo de tasa de cambio', clase: 'celda-enc-texto-corto' },
        { titulo: 'Vinculo a los datos', clase: 'celda-enc-imagen' },
        { titulo: 'Fecha de proxima publicación', clase: 'celda-enc-fecha' }
    ];

    public ENCABEZADO_PRINCIPAL: any = [
        { titulo: 'Categoría', clase: 'celda-enc-texto-medio' },
        { titulo: 'Indicador', clase: 'celda-enc-texto-largo' },
        { titulo: 'Periodicidad', clase: 'celda-enc-texto-corto' },
        { titulo: 'Fecha última publicación disponible', clase: 'celda-enc-fecha' },
        { titulo: 'Unidad de medida', clase: 'celda-enc-texto-corto' },
        { titulo: 'Fecha último dato publicado', clase: 'celda-enc-fecha' },
        { titulo: 'Último dato publicado', clase: 'celda-enc-numero' },
        { titulo: 'Vinculo a los datos', clase: 'celda-enc-imagen' },
        { titulo: 'Fecha de proxima publicación', clase: 'celda-enc-fecha' }
    ];

    public PRECIOS_E_INFLACION: string = 'PRECIOS_E_INFLACION';
    public TASAS_INTERES_Y_SECTOR_FINAN: string = 'TASAS_INTERES_Y_SECTOR_FINAN';
    public OPER_BANCO_MERCADO_Y_RESERV_INTERNAL: string = 'OPER_BANCO_MERCADO_Y_RESERV_INTERNAL';
    public SECTOR_EXT_TASAS_CAMBIO_Y_DERIV: string = 'SECTOR_EXT_TASAS_CAMBIO_Y_DERIV';
    public ACTIV_ECONOM_MERC_LABOR_Y_CTAS_FINAN: string = 'ACTIV_ECONOM_MERC_LABOR_Y_CTAS_FINAN';
    public SECTOR_PUBLICO_Y_DEUDA_PUBLICA: string = 'SECTOR_PUBLICO_Y_DEUDA_PUBLICA';
    public ID_MENU: Array<string> = [this.PRECIOS_E_INFLACION,
    this.TASAS_INTERES_Y_SECTOR_FINAN,
    this.OPER_BANCO_MERCADO_Y_RESERV_INTERNAL,
    this.SECTOR_EXT_TASAS_CAMBIO_Y_DERIV,
    this.ACTIV_ECONOM_MERC_LABOR_Y_CTAS_FINAN,
    this.SECTOR_PUBLICO_Y_DEUDA_PUBLICA];

    public ETIQUETA_TITULO_APLICACION: string = 'Nueva sección - Estadísticas económicas';
    public ETIQUETA_BOTON_APLICACION: string = 'Estadísticas económicas';

    public ETIQUETA_BOTON_ENCUESTA_EXPECTATIVA_BOLETIN: string = 'Datos Encuestas ';
    public ETIQUETA_BOTON_BUSCADOR: string = 'Descarga múltiple de datos';
    public ETIQUETA_BOTON_BUSCADOR_CORTO: string = 'Descarga múltiple de datos';
    public ETIQUETA_BOTON_GRAFICADOR: string = 'Graficador <br> interactivo';
    public ETIQUETA_BOTON_GRAFICADOR_H: string = 'Graficador interactivo';
    public ETIQUETA_BOTON_TABLA_GRAFICO_PRECONSTRUIDO: string = 'Tablas preconstruidas';
    public ETIQUETA_BOTON_CATALOGO: string = 'Catálogo';
    public ETIQUETA_BOTON_DETALLE_CATALOGO: string = 'Detalle catálogo de variables / temáticas';

    public ETIQUETA_BOTON_NUESTROS_DATOS: string = 'Series de estadísticas económicas';

    public ETIQUETA_BOTON_CALENDARIO: string = 'Calendario de publicación de estadísticas';

    public ETIQUETA_BOTON_ENCUESTAS: string = 'Encuestas';
    public ETIQUETA_BOTON_INSTRUCCIONES: string = 'Instrucciones';
    public ETIQUETA_BOTON_BOLETINES: string = 'Boletines';
    public ETIQUETA_BOTON_INDICADORES: string = 'Indicadores económicos del día';
    public ETIQUETA_BOTON_WEB_SERVICE: string = 'Servicios web - SDMX';
    public ETIQUETA_BOTON_HISTORICO: string = 'Series estadísticas históricas de Colombia';

    public PROPIEDAD_SERVIDOR_EXPORTACION = 'URL_SERVIDOR_EXPORTACION';
    public PROPIEDAD_URL_GRAFICADOR = 'URL_APLICACION_GRAFICADOR';
    public PROPIEDAD_URL_INDICADOR_ECONOMICO_DIA = 'URL_APLICACION_INDICADOR_ECONOMICO_DIA';
    public PROPIEDAD_URL_SERIE_HITORICO = 'URL_SERIE_HITORICO';
    public PROPIEDAD_URL_BUSCADOR = 'URL_APLICACION_BUSCADOR';

    public LISTA_METODOLOGIAS = ['FICHA_METODOLOGICA', 'GUIA_METODOLOGICA', 'NOTA_METODOLOGICA', 'MANUAL_USUARIO'];
    public LISTA_NOTAS_FE_ERRATAS = ['FE_DE_ERRATA', 'NOTA_ACLARATORIA'];

    public TIPO_ENCUESTA_CERTIFICADA = 'ENCUESTA_CERTIFICADA';
    public TIPO_ENCUESTA_BASICA = 'ENCUESTA_BASICA';

    public LISTA_IDPLAN_ENCUESTA_CERTIFICADA = ['SALDOS_IPE', 'ENCAJE_EPE_HPE_PSE', 'IBR', 'TASAS_COLOCACION_SEMANAL', 'TASAS_COLOCACION_MENSUAL', 'TASAS_CAPTACION_SEMANAL',
        'REMESAS_MENSUAL', ' REMESAS_TRIMESTRAL', 'DEUDA_EXTERNA', 'ENCAJE_EPE_HPE_PSE', 'AGR_MONET_CREDIT', 'UVR', 'TERMINOS_INTERCAMBIO_CE',
        'RESERVAS_INTERNACIONALES', 'INVERSION_DIRECTA_TRIMESTRAL', 'ITCR', 'ITCR_BILATERAL', 'IPVNBR_MENSUAL', 'IPVU', 'IPVNBR_MENSUAL', 'IPVU',
        'BALANZAPAGOS', 'POSICION_INVERSION_INTERNACIONAL', 'BALANZA_CAMBIARIA_DOMESTICA_MENSUAL', 'BALANZA_CAMBIARIA_DOMESTICA_SEMANAL'];

    public ROUTE_TABLAS_PRECONSTRUIDAS:string = 'dashboard';//'tablasPreconstruidas'
    public ROUTE_CATALOGO:string = 'catalogo';
    public ROUTE_WEB_SERVICE:string = 'webService';
    public ROUTE_ENCUESTAS:string = 'encuestas';
    public ROUTE_BOLETINES:string = 'boletines';
    public ROUTE_CALENDARIO:string = 'calendario';
    public ROUTE_INFORMACION_SERIE:string = 'informacionSerie';

}
